export default __webpack_public_path__ + "static/media/Upload.c84c6aa3.svg";